<template>
  <b-modal
    ref="modal"
    size="fluid"
    :title="modal.title"
    header-bg-variant="light"
    :ok-title="options.okTitle"
    :cancel-title="options.cancelTitle"
    :ok-only="options.okOnly"
    :no-close-on-backdrop="options.noCloseOnBackdrop"
    :no-close-on-esc="options.noCloseOnEsc"
    :hide-header-close="options.hideHeaderClose"
    :modal-class="options.modalClass"
    :ok-variant="'outline-primary'"
    :cancel-variant="'outline-primary'"
    @ok="options.onOk"
    @cancel="options.onCancel"
  >
    <span v-html="modal.text"></span>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      modal: {
        title: '',
        text: '',
      },
      options: {
        okTitle: '',
        cancelTitle: '',
        okOnly: false,
        modalClass: '',
        noCloseOnBackdrop: false,
        noCloseOnEsc: false,
        hideHeaderClose: false,
        onOk: () => {},
        onCancel: () => {},
      },
    }
  },
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
    labels() {
      return this.resources.component.modal.simple
    },
  },
  mounted() {
    this.options.okTitle = this.labels.okTitle
    this.options.cancelTitle = this.labels.cancelTitle
  },
  methods: {
    open() {
      this.$refs.modal.show()
    },
    onOk() {
      this.$emit('modal:simple:on:ok')
    },
    validate(data) {
      if (!data.hasOwnProperty('title'))
        throw Object.assign(new Error('Invalid Simple Modal Payload'), {
          payload: data,
        })
      if (!data.hasOwnProperty('text'))
        throw Object.assign(new Error('Invalid Simple Modal Payload'), {
          payload: data,
        })

      Object.assign(this.modal, data || {})
      this.setOptions(data.options || {})
    },
    setOptions(options) {
      this.options = { ...this.options, ...options }
    },
    setListeners(listeners) {
      Object.keys(listeners).forEach(key => {
        this.$refs.modal.$on(key, listeners[key](this.$refs.modal))
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
